'use es6';

import Raven from 'raven-js';
import { Component } from 'react';
const FIELD_NAME = 'Form';
const ERROR_BOUNDARY_NAME = 'FormErrorBoundary';
const logError = error => {
  Raven.captureException(error, {
    extra: {
      fieldName: FIELD_NAME,
      errorBoundary: ERROR_BOUNDARY_NAME
    }
  });
};
class FormErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    logError(error);
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  render() {
    return this.props.children;
  }
}
export default FormErrorBoundary;